import { render, staticRenderFns } from "./languagewrap.vue?vue&type=template&id=4c498f8b"
import script from "./languagewrap.vue?vue&type=script&lang=ts"
export * from "./languagewrap.vue?vue&type=script&lang=ts"
import style0 from "./languagewrap.vue?vue&type=style&index=0&id=4c498f8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports